/**
 * The picker controls table visibility only. Hiding a column must never alter
 * the payroll rows or any derived payroll/billing amount. Payslip visibility
 * is handled separately by the backend using the persisted hidden keys.
 */
export function applyRemovedColumnsToRows(data = []) {
  return data.map((row) => ({ ...row }))
}
